module.exports = __webpack_public_path__ + "static/media/globy.aa112b09.svg";